import React from 'react'
import ChatList from './chatList'
import NewChatV2 from './chatV2'
import { Link } from 'react-router-dom'
import type { ChatViewMode } from './ChatListSh'

interface ChatsDesktopViewProps {
    chatId?: string
    mode: ChatViewMode
}

const ChatsDesktopView = ({ chatId, mode }: ChatsDesktopViewProps): JSX.Element => {



    return (
        <div className="chats-desktop-shell">



            <div className="chats-desktop">
                <div className="chats-desktop__list">
                    < div className="d-flex gap-2 px-4 pb-2 " >
                        <Link
                            to="?mode=admin"
                            className={`btn btn-sm ${mode === 'admin' ? 'btn-bso' : 'btn-outline-secondary'}`}
                        >
                            Admin chats
                        </Link>

                        <Link
                            to="?mode=observer"
                            className={`btn btn-sm ${mode === 'observer' ? 'btn-bso' : 'btn-outline-secondary'}`}
                        >
                            User chats
                        </Link>
                    </div >
                    <ChatList isDesktop={true} activeChatId={chatId} mode={mode} />
                </div>
                <div className="chats-desktop__chat">
                    {chatId != null
                        ? <NewChatV2 isDesktop={true} readOnly={mode === 'observer'} isAdminMode={mode === 'admin'} />
                        : <div className="d-flex align-items-center justify-content-center h-100 p-10">
                            <div className="card w-100">
                                <div className="card-body text-center">
                                    <div className="fw-bold fs-2 mb-2">Select a chat</div>
                                    <div className="text-muted">Select a chat to start messaging</div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default ChatsDesktopView
